module.exports = __webpack_public_path__ + "static/media/Logo.d29f0769.png";